import { Settings } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const settingsNavigation: NavItem[] = [
  {
    to: '/settings',
    labelKey: 'nav.settings',
    group: 'nav.groups.system',
    icon: Settings,
    permission: 'users.view',
  },
]
